import { PositionsTableProps } from "../../position/components/positions-table";
import { ScopeOfWork } from "../../scope-of-work/types/scope-of-work";
import {
  useOmniContractAddScopeOfWorkPositionMutation,
  useOmniContractPatchScopeOfWorkPositionMutation,
  useOmniContractRemoveScopeOfWorkPositionMutation,
  useOmniContractRemoveScopeOfWorkPositionsByGroupingMutation,
  useOmniContractRenameScopeOfWorkGroupingMutation,
} from "../api/contract-api";
import { Contract } from "../types/contract";

/**
 * useContractScopeOfWorkPositionsProps returns the props of a
 * {@link PositionsTable} editing the positions of the scope of work of
 * the contract, all but its config.
 */
export function useContractScopeOfWorkPositionsProps(
  contract: Contract,
  scopeOfWork: ScopeOfWork,
): Omit<PositionsTableProps, "config"> {
  const ids = { id: contract.id, scopeOfWorkId: scopeOfWork.id };
  const [add] = useOmniContractAddScopeOfWorkPositionMutation();
  const [patch] = useOmniContractPatchScopeOfWorkPositionMutation();
  const [remove] = useOmniContractRemoveScopeOfWorkPositionMutation();
  const [rename] = useOmniContractRenameScopeOfWorkGroupingMutation();
  const [removeGrouping] =
    useOmniContractRemoveScopeOfWorkPositionsByGroupingMutation();

  return {
    document: contract,
    positions: scopeOfWork.positions,
    fieldNamePrefix: `scopeOfWork.${scopeOfWork.id}.`,
    onPositionAdd: (r) => add({ ...r, ...ids }).unwrap(),
    onPositionPatch: (r) => patch({ ...r, ...ids }).unwrap(),
    onPositionRemove: (r) => remove({ ...r, ...ids }).unwrap(),
    onGroupingRename: (r) => rename({ ...r, ...ids }).unwrap(),
    onGroupingRemove: (r) => removeGrouping({ ...r, ...ids }).unwrap(),
  };
}
